export interface Category {
  name: string;
  url: string;
  imageUrl: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20placed%20on%20textured%20urban%20concrete%20surface%20with%20morning%20sunlight%20casting%20long%20shadows%2C%20minimal%20street%20style%20editorial%20photography%2C%20warm%20golden%20hour%20tones%2C%20clean%20sharp%20details%20on%20stitching%20and%20sole%20texture&width=600&height=450&seq=shoe-urban-lifestyle-v2&orientation=landscape',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Chunky%20knit%20oatmeal%20sweater%20draped%20casually%20over%20a%20vintage%20wooden%20armchair%20near%20a%20bright%20window%2C%20soft%20diffused%20daylight%20illuminating%20the%20cable%20knit%20texture%2C%20cozy%20Scandinavian%20interior%20aesthetic%2C%20cream%20and%20warm%20beige%20palette&width=600&height=450&seq=hoodie-knit-texture-v2&orientation=landscape',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Organic%20cotton%20crew%20neck%20t-shirt%20neatly%20folded%20on%20natural%20undyed%20linen%20fabric%2C%20surrounded%20by%20dried%20eucalyptus%20branches%20and%20a%20small%20ceramic%20vase%2C%20soft%20morning%20light%20from%20left%20side%2C%20earthy%20sage%20and%20sand%20tones&width=600&height=450&seq=tshirt-botanical-flatlay-v2&orientation=landscape',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Vintage%20wash%20denim%20jacket%20hanging%20on%20a%20rustic%20iron%20wall%20hook%20against%20exposed%20brick%20texture%2C%20warm%20afternoon%20sunlight%20streaming%20diagonally%2C%20detailed%20brass%20button%20and%20stitching%20visible%2C%20industrial%20loft%20aesthetic%20with%20soft%20shadows&width=600&height=450&seq=jacket-denim-wall-v2&orientation=landscape',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Well%20tailored%20slim%20fit%20chino%20trousers%20on%20a%20wooden%20hanger%20against%20a%20soft%20sage%20green%20plaster%20wall%2C%20gentle%20side%20lighting%20creating%20subtle%20fabric%20highlights%2C%20minimal%20editorial%20style%2C%20warm%20khaki%20and%20olive%20tones&width=600&height=450&seq=pants-tailored-hanger-v2&orientation=landscape',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Classic%20six%20panel%20dad%20cap%20in%20dusty%20rose%20color%20resting%20on%20a%20weathered%20oak%20floating%20shelf%2C%20warm%20golden%20sunlight%20from%20nearby%20window%2C%20subtle%20fabric%20texture%20visible%2C%20minimalist%20interior%20with%20cream%20wall%20background&width=600&height=450&seq=headwear-cap-shelf-v2&orientation=landscape',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Coordinated%20two%20piece%20linen%20set%20in%20warm%20terracotta%20tone%20laid%20flat%20on%20honed%20white%20marble%20surface%2C%20a%20single%20monstera%20leaf%20nearby%2C%20soft%20overhead%20natural%20light%2C%20editorial%20minimalist%20composition%20with%20gentle%20fabric%20folds&width=600&height=450&seq=sets-coord-marble-v2&orientation=landscape',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Soft%20modal%20cotton%20underwear%20set%20in%20warm%20sand%20color%20arranged%20on%20textured%20organic%20cotton%20fabric%20surface%2C%20dried%20lavender%20sprigs%20scattered%20delicately%2C%20soft%20window%20light%2C%20clean%20minimal%20composition%20with%20gentle%20shadows&width=600&height=450&seq=underwear-organic-surface-v2&orientation=landscape',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Professional%20athletic%20jersey%20in%20deep%20charcoal%20with%20subtle%20mesh%20texture%20draped%20over%20a%20wooden%20locker%20room%20bench%2C%20dramatic%20side%20lighting%20through%20blinds%2C%20moody%20atmospheric%20sports%20photography%2C%20rich%20contrast%20with%20warm%20accents&width=600&height=450&seq=jersey-sport-locker-v2&orientation=landscape',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Minimalist%20fashion%20accessories%20including%20a%20thin%20gold%20chain%20necklace%20and%20a%20leather%20wrap%20bracelet%20on%20raw%20slate%20stone%20surface%2C%20soft%20afternoon%20light%20creating%20delicate%20highlights%2C%20editorial%20jewelry%20photography%2C%20warm%20metallic%20and%20dark%20stone%20contrast&width=600&height=450&seq=accessories-stone-display-v2&orientation=landscape',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Full%20grain%20leather%20backpack%20in%20rich%20cognac%20brown%20resting%20on%20a%20vintage%20leather%20club%20chair%2C%20warm%20reading%20lamp%20glow%20from%20the%20side%2C%20brass%20hardware%20details%20catching%20light%2C%20cozy%20library%20atmosphere%20with%20dark%20wood%20tones&width=600&height=450&seq=bags-leather-chair-v2&orientation=landscape',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Handcrafted%20braided%20leather%20belt%20in%20chestnut%20brown%20coiled%20naturally%20on%20a%20rough%20sawn%20wooden%20tree%20stump%20slice%2C%20dappled%20sunlight%20through%20leaves%20creating%20organic%20light%20patterns%2C%20rustic%20artisan%20photography%2C%20warm%20earthy%20textures&width=600&height=450&seq=belts-braided-stump-v2&orientation=landscape',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Artisan%20amber%20glass%20fragrance%20bottle%20with%20minimal%20label%20on%20polished%20black%20marble%20surface%2C%20a%20single%20dried%20rose%20petal%20beside%20it%2C%20dramatic%20spotlight%20from%20above%20creating%20reflection%2C%20luxury%20product%20photography%20with%20deep%20contrast&width=600&height=450&seq=perfumes-marble-dramatic-v2&orientation=landscape',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Eclectic%20curated%20lifestyle%20collection%20with%20a%20ceramic%20mug%20and%20notebook%20and%20candle%20on%20reclaimed%20barn%20wood%20surface%2C%20warm%20afternoon%20sunlight%20across%20the%20scene%2C%20thoughtful%20flatlay%20composition%20with%20natural%20textures%2C%20cozy%20rustic%20modern%20aesthetic&width=600&height=450&seq=other-reclaimed-wood-v2&orientation=landscape',
  },
];